module.exports = __webpack_public_path__ + "assets/bell notification.0de77537.svg";